import { Box, InputBase, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next"
import { tokens } from "../../../theme";
import Text from "../../theme/text/Text";

export const SHPBBorder = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const {t} = useTranslation();
    return (
        <Box>
            <Text>
            {t("border")}
            </Text>
            <Box
                sx={{
                    pt:1,
                    width:1,
                }}
            >
                <Text>{t("corner_radius")}</Text>
                <Box
                    sx={{
                        display:"flex",
                        height:40,
                        background: colors.bg['tertiary'],
                        alignItems:"center",
                        pl:1,
                        pr:0.5,
                        bordrRadius:5,
                    }}
                >

                    <InputBase
                        // value={localValue}
                        // onInput={changeHex}
                        sx={{
                            ml:1.5,
                            flex:1,
                            color: colors.txt["primary"],
                            fontFamily:"Roboto, sans-serif",
                        }}
                    />
                    <Box
                        // onClick={handleFilterPopoverClick}
                        sx={{
                            borderRadius:4,
                            height:32,
                            width:32,
                            flexShrink:0,
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                            // background:localValue ? `rgba(${hexToRgb(localValue)},${props.value.opacity})` : "#fff",
                        }}
                    >

                    </Box>
                   
                </Box>
                border itself
                    - Color
                    - Thickness
                        - split between 4 borders
            </Box>
        </Box>
    )
}